import moment from "moment";
import store from "../store/index";
import router from "../router";

export default class RoundFunctions {
    static getDayOfWeek(date) {
        return moment(date).format('dddd')
    }

    static getDay(date) {
        return moment(date).format('Do')
    }

    static getMonth(date) {
        return moment(date).format('MMMM')
    }

    static getYear(date) {
        return moment(date).format('YYYY')
    }

    static getTime(date) {
        return moment(date).format('hh:mm a')
    }

    static onRoundClicked(round, sport) {
        store.commit('setSelectedRound', round);
        if (round.HasPredictions) {
            router.push(`predictions/${sport.toLowerCase()}/view-predictions`);
        } else {
            router.push(`predictions/${sport.toLowerCase()}/make-predictions`);
        }
    }

    static hasEndDatePassed(round) {
        const currentDate = new Date();
        const formattedCurrentDate = moment(currentDate).format();
        const formattedRoundEndDAte = moment(round.RoundEndDate).format();

        if (formattedRoundEndDAte > formattedCurrentDate) return true;
        else return false;
    }
}
